import React from 'react';
import { Typography, Button } from '@sm/wds-react';
import { BasePage, Helmet, LogoWithText } from '@sm/webassets';
import { defineMessages, T } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';
import './link-blocked.scss';

const COPY = defineMessages({
  LINK_BLOCKED_MAIN_MESSAGE: {
    id: 'LinkBlocked.MainMessage',
    defaultMessage: "The link you clicked was blocked due to a violation of SurveyMonkey's Terms of Use.",
    description: '[Type: Link][Vis.: Low] - The link blocked page main message',
  },
  LINK_BLOCKED_PAGE_TITLE: {
    id: 'LinkBlocked.PageTitle',
    defaultMessage: 'Link blocked',
    description: '[Type: Link][Vis.: Low] - The link blocked page title',
  },
  LINK_BLOCKED_SIGN_UP_BLURB: {
    id: 'LinkBlocked.SignUpBlurb',
    defaultMessage: 'Want to create your own survey?',
    description: '[Type: Link][Vis.: Low] - A blurb for a link that will direct users to the sign up page',
  },
  LINK_BLOCKED_SIGN_UP: {
    id: 'LinkBlocked.SignUp',
    defaultMessage: 'Sign Up FREE',
    description: '[Type: Link][Vis.: Low] - A link that will direct users to the sign up page',
  },
  LINK_BLOCKED_HOME: {
    id: 'LinkBlocked.SMHome',
    defaultMessage: 'SurveyMonkey Home',
    description: '[Type: Link][Vis.: Low] - A link that will direct users to the homepage',
  },
  LINK_BLOCKED_TERMS_OF_USE: {
    id: 'LinkBlocked.TermsofUse',
    defaultMessage: 'Terms of Use',
    description: '[Type: Link][Vis.: Low] - A link that will direct users to the Terms of Use page',
  },
});

const LinkBlocked = () => (
  <BasePage color="transparent" includeHeader={false} includeFooter={false} pageId="Link Blocked" legacyWeb="anonweb">
    <Helmet>
      <title>{T(COPY.LINK_BLOCKED_MAIN_MESSAGE)}</title>
      <meta
        name="keywords"
        content="questionnaire, questionnaires, questionaire, questionaires, free online survey, free online surveys"
      />
      <meta
        name="description"
        content="Create and publish online surveys in minutes, and view results graphically and in real time. SurveyMonkey provides free online questionnaire and survey software."
      />
    </Helmet>
    <div data-testid="LinkBlocked" className="sm-link-blocked__page sm-link-blocked--center">
      <div className="sm-link-blocked__message-wrapper">
        <a
          href="/"
          className="sm-link-blocked__logo"
          data-sm-metrics={generateMetricsAttribute({
            data: {
              actionType: 'link_blocked_click_logo_to_homepage',
              actionFlow: 'LinkBlocked',
            },
          })}
        >
          <LogoWithText />
        </a>
        <Typography variant="pageTitle">
          <T desc={COPY.LINK_BLOCKED_PAGE_TITLE} />
        </Typography>
        <div className="sm-link-blocked__message-container">
          <Typography variant="sectionTitle" className="wds-m-b-5">
            <T desc={COPY.LINK_BLOCKED_MAIN_MESSAGE} />
          </Typography>
          <Typography component="div" variant="cardTitle" className="wds-p-1">
            <T desc={COPY.LINK_BLOCKED_SIGN_UP_BLURB} />
          </Typography>
          <Button
            color="upgrade"
            href="/user/sign-up/?ut_source=link_blocked_page"
            data-sm-metrics={generateMetricsAttribute({
              data: {
                actionType: 'link_blocked_click_to_sign_up',
                actionFlow: 'LinkBlocked',
              },
            })}
          >
            <T desc={COPY.LINK_BLOCKED_SIGN_UP} />
          </Button>
          <div className="sm-link-blocked__links-container wds-m-4">
            <ul className="sm-link-blocked__links-list">
              <li className="sm-link-blocked__list-item sm-link-blocked--center">
                <a
                  href="/"
                  data-sm-metrics={generateMetricsAttribute({
                    data: {
                      actionType: 'link_blocked_click_to_home',
                      actionFlow: 'LinkBlocked',
                    },
                  })}
                >
                  <T desc={COPY.LINK_BLOCKED_HOME} />
                </a>
              </li>
              <li className="sm-link-blocked__list-item sm-link-blocked--center">
                <a
                  href="/mp/legal/terms-of-use/"
                  data-sm-metrics={generateMetricsAttribute({
                    data: {
                      actionType: 'link_blocked_click_to_terms_of_use',
                      actionFlow: 'LinkBlocked',
                    },
                  })}
                >
                  <T desc={COPY.LINK_BLOCKED_TERMS_OF_USE} />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <span className="sm-link-blocked__text-id" />
      </div>
    </div>
  </BasePage>
);

export default LinkBlocked;
